import React from "react";
// import HomeBanner from "../../../src/assets/images/home/banner_3.webp";
// import HomeBanner from "../../assets/images/university/learning.webp";
import HomeBanner from "../../assets/images/home/homeBanner.webp";

import BeyondImg1 from "../../assets/images/home/what_its.webp";
import BeyondImg2 from "../../assets/images/home/campus.webp";
import BeyondImg3 from "../../assets/images/home/sports.webp";
import BeyondImg4 from "../../assets/images/home/stuPro.webp";
import founderImage from "../../assets/images/home/founder.webp";
import { Link } from "react-router-dom";
import INDUSTRY_CONNECTIONS from "../../dummyData/IndustryConnections.json";
import "./style.scss";
import CollageCarousel from "../../components/sections/CollageCarousel";
import { APPLICATION_OPEN_DATE, APPLICATION_CLOSE_DATE } from "../../constants";

const HomePage = () => {
  const today = new Date();
  const applicationOpenDate = APPLICATION_OPEN_DATE;
  const applicationCloseDate = APPLICATION_CLOSE_DATE;
  // const [products, setProducts] = useState([
  //   "10",
  //   "11",
  //   "12",
  //   "13",
  //   "14",
  //   "15",
  //   "16",
  //   "17",
  //   "18",
  // ]);

  // const productTemplate = (product) => {
  //   return (
  //     <div className="border-1 surface-border border-round m-2 text-center px-0">
  //       <div>
  //         <h3 className="mb-1 sh-upcoming--eventsdate">{product}</h3>
  //         <h6 className="mt-0 mb-3 sh-upcoming--eventsmonth">june</h6>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <>
      <section className="sh-home--banner">
        <div className="sh-home--banner-container">
          <img
            className="sh-home--banner-image"
            src={HomeBanner}
            alt="Home Banner"
            draggable="false"
          />
          <div className="sh-home--banner-text">
            <h4>
              Building AI talent for India,
              <br /> in India.
            </h4>
          </div>
        </div>
      </section>

      {/* Section: Intake Apply */}
      {today > applicationOpenDate && today <= applicationCloseDate && <section className="global-blue--strip mt-5">
        <div className="container">
        <div className="d-flex align-items-center gap-5">
            <div>
              <p className="global-blue--stripapplytitle">Admissions for 2026 are now open</p>
              <h2 className="global-blue--stripapplybtn">Apply now</h2>
            </div>
            
            <Link to={"https://admissions.sitare.org/"} target="_blank" className="global-blue--striparrow">
              <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div> 
        </div>
      </section> }

      {/* Section: Apply Now */}
      {/* <section className="application-dates">
        <div className="row">
          <div className="col-12 sh-beyond--heading_admission">
            <h1 className="global-heading">Admissions for 2026 are now open</h1>
          </div>
        </div>
        {today > applicationOpenDate && today <= applicationCloseDate && <div className="mb-5 mt-5 apply-link">
          <Link
            to={
              "https://admissions.sitare.org/"
            }
            target="_blank"
            className="global-orangeBtn"
          >
            Apply Now
          </Link>
        </div>}
      </section> */}

      {/* Section: Transforming Lives */}
      <section className="global-aboutwrapper">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12 col-lg-10">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <h1 className="global-heading">
                    Transforming Lives through World-Class Computer Science
                    Education
                  </h1>
                </div>
                <div className="col-lg-6 col-12">
                  <p className="global-bodytext">
                    Sitare University Program believes in the power of education
                    to drive social upliftment and personal transformation.
                    Established in 2022 by Dr. Amit Singhal (former SVP of
                    Google Search, an ACM Fellow, and a member of the National
		    Academy of Engineering in the United States), our mission is to provide
                    top-tier Computer Science education to bright students from
                    economically disadvantaged backgrounds. We aim to cultivate
                    future leaders in technology who will drive innovation and
                    change across the globe.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section: Services options */}
      <section className="container-fluid px-0">
        <div className="row mx-0">
          <div className="col-12 px-0">
            <div className="sh-service--grid">
              <Link to={"/placements"} className="sh-service--griditem box1">
                Placements
              </Link>
              <Link to={"/academic-Life"} className="sh-service--griditem box2">
                Academic
                <br />
                Life
              </Link>

              <Link to={"/facilities"} className="sh-service--griditem box3">
                University
                <br />
                Life
              </Link>
              <Link to={"/why-sitare"} className="sh-service--griditem box4">
                About Us
              </Link>
              <Link to={"/curriculum"} className="sh-service--griditem box5">
                Our
                <br />
                Curriculum
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Section: Innovative Curriculum */}
      <section className="sh-innovative">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12 col-lg-10">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <div>
                    <h1 className="global-heading mt-2 pe-lg-3">
                      Innovative Curriculum Designed for Industry Success
                    </h1>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <ul className="sh-innovative--list">
                    <li>
                      <b>Industry-Focused Education</b>
                      <p>
                        Our courses are designed to align perfectly with
                        industry requirements, ensuring students are job-ready
                        from day one.
                      </p>
                    </li>
                    <li>
                      <b>Hands-On Learning</b>
                      <p>
                        Emphasis on project-based learning allows students to
                        apply theoretical knowledge to practical problems.
                      </p>
                    </li>
                    <li>
                      <b>Personalized Attention</b>
                      <p>
                        With small class sizes and dedicated faculty, each
                        student receives the attention and support they need to
                        excel.
                      </p>
                    </li>
                    <li>
                      <b>Paid Internships</b>
                      <p>
                        Starting right after the second year, our students gain
                        valuable industry experience through paid internships.
                      </p>
                    </li>
                    <li>
                      <b>Industry Immersion</b>
                      <p>
                        The final year is completely spent working in the
                        industry, giving students a significant head start in
                        their careers.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section: Beyond Lecture Hall */}
      <section className="container">
        <div className="row">
          <div className="col-12 sh-beyond--heading">
            <h1 className="global-heading">Beyond the lecture hall</h1>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-12 col-xl-10">
            <div>
              <ul className="sh-beyond--wrapper">
                <li className="sh-beyond--wrapper-li position-relative">
                  <Link to={"https://youtu.be/RXCVtfYnCg4?si=8UlgPiDON4RZzzQP"} target="_blank"
                    title="Play Video" className="d-block">
                    <img
                      className="sh-beyond--wrapper-img"
                      src={BeyondImg1}
                      alt="service"
                      draggable="false"
                    />
                    <div className="sh-beyond--wrapper-text">
                      <span className="sh-beyond--wrapperplay">
                        <i className="fa-regular fa-circle-play"></i>
                      </span>

                      <span className="sh-beyond--wrapper-textname">
                        What it’s like to be at Sitare?
                      </span>
                    </div>
                  </Link>
                </li>

                {/* <li className="sh-beyond--wrapper-li">
                  <img
                    className="sh-beyond--wrapper-img"
                    src={BeyondImg2}
                    alt="service"
                    draggable="false"
                  />
                  <div className="sh-beyond--wrapper-text">
                    <Link to={'/'} className="sh-beyond--wrapper-textname">Alumni</Link>
                  </div>
                </li> */}

                <li className="sh-beyond--wrapper-li position-relative mt-3 md-mt-0">
                  <Link to={"/facilities"}>
                    <div className="position-relative sh-beyond--wrapper-inner">
                      <img
                        className="sh-beyond--wrapper-img"
                        src={BeyondImg2}
                        alt="service"
                        draggable="false"
                      />
                      <div className="sh-beyond--wrapper-text">
                        <span className="sh-beyond--wrapper-textname">
                          Our Campus
                        </span>
                      </div>
                    </div>
                  </Link>

                  <Link to={"/sports"}>
                    <div className="position-relative sh-beyond--wrapper-innersport">
                      <img
                        className="sh-beyond--wrapper-img"
                        src={BeyondImg3}
                        alt="service"
                        draggable="false"
                      />
                      <div className="sh-beyond--wrapper-text">
                        <span className="sh-beyond--wrapper-textname">
                          Sports & Club
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>

                <li className="sh-beyond--wrapper-li position-relative mt-3 md-mt-0">
                  <Link to={"/student-projects"}>
                    <div>
                      <img
                        className="sh-beyond--wrapper-img"
                        src={BeyondImg4}
                        alt="service"
                        draggable="false"
                      />
                    </div>
                    <div className="sh-beyond--wrapper-text">
                      <span className="sh-beyond--wrapper-textname">
                        student projects
                      </span>
                    </div>
                  </Link>
                </li>

                {/* <li className="sh-beyond--wrapper-li">
                  <img
                    className="sh-beyond--wrapper-img"
                    src={BeyondImg2}
                    alt="service"
                    draggable="false"
                  />
                  <div className="sh-beyond--wrapper-text">
                  <Link to={'/'} className="sh-beyond--wrapper-textname">events & fests</Link>
                  </div>
                </li> */}

                {/* <li className="sh-beyond--wrapper-li">
                  <img
                    className="sh-beyond--wrapper-img"
                    src={BeyondImg5}
                    alt="service"
                    draggable="false"
                  />
                  <div className="sh-beyond--wrapper-text">
                  <Link to={'/'} className="sh-beyond--wrapper-textname">faculty research</Link>
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section: News and Updates */}
      {/* <section className="sh-news py-5">
        <div className="container">
          <div className=" row mb-md-5">
            <div className="col-12">
              <p className="sh-news--subheading">News and Updates</p>
              <h2 className="global-heading">What's happening at Sitare?</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="sh-news--articles mb-4 mb-lg-0">
                <div className="row">
                  <div className="col-md-5 col-12">
                    <div>
                      <img
                        src="https://via.placeholder.com/150"
                        alt=""
                        className="sh-news--articlesimg"
                      />
                      <div className="sh-news--articlesdisplay">
                        <p className="mb-0">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit
                        </p>
                        <i className="fa-solid fa-arrow-up"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 mt-3 mt-md-0">
                    {/* Item 1 */}
      {/* <div className="sh-news--articlesitem">
                      <img
                        src="https://via.placeholder.com/150"
                        alt=""
                        className="sh-news--articlesitemthumb"
                      ></img>
                      <div>
                        <p className="sh-news--articlesitemdesc">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit lorem
                        </p>
                        <Link
                          to={"/"}
                          className="sh-news--articlesitemmore my-1"
                        >
                          Read more
                        </Link>
                        <p className="sh-news--articlesitemdate">
                          Wednesday, 14 June, 2024
                        </p>
                      </div>
                    </div> */}

      {/* Item 2 */}
      {/* <div className="sh-news--articlesitem">
                      <img
                        src="https://via.placeholder.com/150"
                        alt=""
                        className="sh-news--articlesitemthumb"
                      ></img>
                      <div>
                        <p className="sh-news--articlesitemdesc">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit lorem
                        </p>
                        <Link
                          to={"/"}
                          className="sh-news--articlesitemmore my-1"
                        >
                          Read more
                        </Link>
                        <p className="sh-news--articlesitemdate">
                          Wednesday, 14 June, 2024
                        </p>
                      </div>
                    </div> */}

      {/* Item 3 */}
      {/* <div className="sh-news--articlesitem">
                      <img
                        src="https://via.placeholder.com/150"
                        alt=""
                        className="sh-news--articlesitemthumb"
                      ></img>
                      <div>
                        <p className="sh-news--articlesitemdesc">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit lorem
                        </p>
                        <Link
                          to={"/"}
                          className="sh-news--articlesitemmore my-1"
                        >
                          Read more
                        </Link>
                        <p className="sh-news--articlesitemdate">
                          Wednesday, 14 June, 2024
                        </p>
                      </div>
                    </div> */}
      {/* <div className="mt-4 mb-0 text-end"> */}
      {/* View All Articles */}
      {/* <Link to={"/news-updates"} className="sh-news--viewall">
                        View All Articles
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

      {/*<div className="col-lg-4 col-12">
              <div className="sh-upcoming">
                <div className="sh-upcoming--header">
                  <p>upcomming events</p>
                  <Link to={"/"} className="sh-upcoming--headerviewall">
                    View all
                  </Link>
                </div>
                <div className="sh-upcoming--events">
                  <Carousel
                    value={products}
                    numVisible={3}
                    numScroll={3}
                    // responsiveOptions={responsiveOptions}
                    className="custom-carousel"
                    circular
                    showIndicators={false}
                    autoplayInterval={0}
                    itemTemplate={productTemplate}
                    prevIcon={<i className="fa-solid fa-angle-left"></i>}
                    nextIcon={<i className="fa-solid fa-angle-right"></i>}
                  />
                </div>
                <p className="sh-upcoming--eventsdesc">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur.
                </p>
                <Link to={"/"} className="sh-upcoming--headerviewall">
                  View this event
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Section: Student Life */}
      <section className="container-fluid px-0">
        <div className="row mx-0">
          <div className="col-12 px-0">
            <div className="sh-studentlife--grid">
              <div className="sh-studentlife--griditem box1">
                University Life
                <br />
                at Sitare
              </div>
              <Link to={"/hostels"} className="sh-studentlife--griditem box2">
                <span>Hostel</span>
              </Link>
              <Link to={"/cafeteria"} className="sh-studentlife--griditem box3">
                <span>Cafeteria</span>
              </Link>
              <Link to={"/gym"} className="sh-studentlife--griditem box4">
                <span>Gym</span>
              </Link>
              <Link to={"/sports"} className="sh-studentlife--griditem box5">
                <span>sports</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Section: Industry Carousel */}
      <section className="container">
        <div className="sh-connections global-aboutwrapper pt-0">
          <div className="row">
            <div className="col-12 global-section--center">
              <h1 className="global-heading text-center mb-0">
                Our industry connections
              </h1>
            </div>
          </div>

          <CollageCarousel data={INDUSTRY_CONNECTIONS} />
        </div>
      </section>

      {/* Section: Enquire Now */}
      {/* <section className="global-blue--strip mt-5">
        <div className="container">
          <div className="d-flex align-items-center gap-5">
            <div>
              <p className="global-blue--stripapplytitle">Want to know more?</p>
              <h2 className="global-blue--stripapplybtn">Contact Us</h2>
            </div>
            <Link to={"/contact-us"} className="global-blue--striparrow">
              <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </section> */}

      {/* Section: Founder Quote */}
      <section className="container-fluid px-0">
        <div className="row mx-0">
          <div className="col-lg-7 col-md-6 col-12 px-0">
            <div className="sh-founder">
              <img
                className="sh-founder--img"
                src={founderImage}
                alt="founder"
                draggable="false"
              />
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-12 px-0">
            <div className="sh-founder--quote">
              <h1>A quote from the founder.</h1>
              <p>
                &quot;The future belongs to nations who can make fundamental advances
                in Computer Science.&quot;
              </p>
              <Link to={"/why-sitare"} className="global-orangeBtn">
                know more
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
